<script setup lang="ts">
import { LandingContentsParentEnum } from '@clients/ContentApi';
import type LandingContent from '@store/content/entities/LandingContent';

const { pageData } = defineProps<{
    pageData?: LandingContent;
}>();
</script>
<template>
    <div v-if="pageData?.linkBox?.length" class="busy-way-container">
        <mr-typography
            type="h3"
            size="x-large"
            weight="700"
            color="var(--cool-gray-800)"
            align="center"
            class="header"
        >
            مسیرهای پرتردد
            <span
                v-if="
                    pageData.parent !== LandingContentsParentEnum.Flights &&
                    pageData.parent !== LandingContentsParentEnum.TrainTicket &&
                    pageData.parent !== LandingContentsParentEnum.Buses &&
                    pageData.cityName
                "
            >
                به مقصد
                {{ pageData.cityName }}
            </span>
        </mr-typography>
        <mr-typography
            size="small"
            weight="300"
            align="center"
            color="var(--cool-gray-800)"
            class="note"
        >
            ارزان ترین و سریعترین مسیرها را با بیش از 500 شریک رسمی انتخاب کنید
        </mr-typography>
        <div class="content">
            <div
                v-for="(destination, index) in pageData.linkBox"
                :key="index"
                class="list-item-container"
            >
                <div class="list-item">
                    <a v-if="destination.url" :href="destination.url">
                        {{ destination.title }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
.busy-way-container {
    background: usePalette($p-blue, $p-100);
    padding: 32px 0 48px 0;
}

.note {
    margin-bottom: 20px;
}

.busy-way-container .content {
    display: flex;
    width: $app-container-max-width;
    margin: auto;
    flex-wrap: wrap;
    justify-content: flex-start;
}

.list-item-container {
    width: 16.666%;
    padding: 2px 4px;
}

@media (max-width: $app-mobile-max-width) {
    .busy-way-container .content {
        flex-wrap: wrap;
        flex-direction: column;
        align-items: center;
        width: 100%;
        padding: 16px;
    }

    .header {
        max-width: 190px;
        margin: 0 auto;
    }

    .list-item-container {
        width: 100%;
    }
}
</style>
